import { render, staticRenderFns } from "./company.vue?vue&type=template&id=129c8d2c&scoped=true"
import script from "./company.vue?vue&type=script&lang=js"
export * from "./company.vue?vue&type=script&lang=js"
import style0 from "./company.vue?vue&type=style&index=0&id=129c8d2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129c8d2c",
  null
  
)

export default component.exports